//eslint-disable-next-line import/prefer-default-export
export const lsColors = {
    'gray-primary': '#a0a8c5',
    'gray-invert': '#fff',
    'gray-primary-hover': '#858ba4',
    primary: '#5b74ff',
    'primary-invert': '#fff',
    'primary-light': '#abb4ff',
    'primary-light-invert': '#fff',
    'primary-dark': '#5867dd',
    'primary-dark-invert': '#fff',
    'primary-darker': '#645ca1',
    'primary-darker-invert': '#fff',
    secondary: '#646c9a',
    'secondary-invert': '#fff',
    'secondary-light': '#e2e5ec',
    'secondary-light-invert': '#fff',
    'secondary-dark': '#3d4465',
    'secondary-dark-invert': '#fff',
    'secondary-darker': '#212529',
    'secondary-darker-invert': '#fff',
    info: '#ff9900',
    'info-invert': '#fff',
    'info-hover': '#de8500',
    danger: '#e02020',
    'danger-invert': '#fff',
    'danger-hover': '#c01b1b',
    success: '#01be47',
    'success-invert': '#fff',
    'success-hover': '#009236',
    transparent: 'transparent',
    white: '#fff',
};
